import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToggleV3Component } from '@gea/digital-ui-lib';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { FeatureFlag } from '../../../user-management.model';

@Component({
  selector: 'app-access-control',
  imports: [ToggleV3Component, TooltipModule, ReactiveFormsModule, SkeletonModule],
  templateUrl: './access-control.component.html',
  styleUrl: './access-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessControlComponent {
  @Input({ required: true }) flagsForm!: FormGroup;
  @Input({ required: true }) allFlags: FeatureFlag[] = [];

  readonly skeletonItems = Array(12);
}
